<template>
	<div class='block-main-attendees'>
			<span>{{title}}</span>
			<ul class='block-live-profiles'>
        <li v-for='attendee in attendees'>
          <div class='block-profile-image'>
            <div class='block-image-wrapper'>
              <img class='block-image' :src='attendee.PictureUrl' :alt='attendee.Name' :title='attendee.Name' />
            </div>
          </div>
          <div class='block-profile-content'>{{attendee.Name}}</div>
        </li>
      </ul>
	</div>
</template>

<script>
import lang from '../../lang'

export default {
  name: 'top-text-box-government-attendees',
  data () {
    return {
      title: lang.attendeesFromGovernment[this.$root.cmsData.lang],
      attendees: this.$root.liveData.MeetingActivity.ParticipatingGovernmentMemberList
    }
  }
}
</script>



// WEBPACK FOOTER //
// TopTextBoxGovernmentAttendees.vue?28c700de